import Parse from 'parse';

const AdminCalendarModule = {
  namespaced: true,
  state: {
    events: {},
    lastData: null,
    eventsForADay: {},
  },
  mutations: {
    addEvents(state, { response, key }) {
      state.events[key] = response;
      //Vue.set(state.events, key, response);
    },
    resetEvents(state) {
      state.events = {};
    },
    setLastData(state, lastData) {
      state.lastData = lastData;
    },
    setEventsForADay(state, dd) {
      state.eventsForADay = dd;
    },
  },
  actions: {
    async loadEvents({ commit, state }, data) {
      commit('setLastData', data);
      const key = `${data.fromYear}-${data.fromMonth}-${data.toYear}-${data.toMonth}`;

      if (state.events[key]) return;
      try {
        let response = await Parse.Cloud.run('getAdminCalendarEvents', data, {});
        response = response.map((el) => {
          el.dates = new Date(el.dates);
          return el;
        });
        commit('addEvents', { response, key });
      } catch (e) {
        console.log(e);
      }
    },
    async reloadEvents({ state, commit, dispatch }) {
      commit('resetEvents');
      await dispatch('loadEvents', state.lastData);
    },
    async loadEventsForADay({ commit }, date) {
      try {
        const response = await Parse.Cloud.run('getCalendarEventsForDate', { date: date.toDateString() }, {});
        commit('setEventsForADay', response);
      } catch (e) {
        // eslint-disable-next-line
        console.log(e);
      }
    },
    async loadCalendarEventsExport({ state, commit }, payload) {
      return await Parse.Cloud.run(
        'loadCalendarEventsExport',
        { year: payload.year, month: payload.month, calendarConfig: payload.calendarConfig },
        {}
      );
    },
    async updateSickDayReports({ state }, { user, sickDays }) {
      const query = new Parse.Query('CalendarEvent');
      query.equalTo('user', user);
      query.equalTo('type', 'kr');
      query.containedIn('day', sickDays);
      try {
        const result = await query.find();
        result.forEach((calEvent) => {
          const customData = calEvent.get('customData');
          calEvent.set('customData', customData?.sickDayReport ? { sickDayReport: false } : { sickDayReport: true });
        });

        result.forEach(async (calendarEvent) => await calendarEvent.save());
      } catch (e) {
        console.log(e);
      }
    },
    async loadSickDaysExport({ dispatch }, { year, workingGroups }) {
      const query = new Parse.Query('CalendarEvent');
      query.select('user', 'type');
      query.greaterThanOrEqualTo('day', new Date(Date.UTC(year, 0, 1, 0, 0, 0, 0)));
      query.lessThan('day', new Date(Date.UTC(year + 1, 0, 1, 0, 0, 0, 0)));
      query.containedIn('type', ['kr', 'ko']);
      query.limit(30000);
      let result = await query.find();

      const hashTable = {};
      let user = '';
      for (const entry of result) {
        user = String(entry.get('user').get('employeeId'));

        if (user in hashTable) entry.get('type') === 'kr' ? hashTable[user][5]++ : hashTable[user][6]++;
        else {
          hashTable[user] = [
            Number(user),
            entry.get('user').get('firstname'),
            entry.get('user').get('lastname'),
            entry.get('user').get('isActive')
              ? await dispatch('getSuperior', { user: entry.get('user'), wGs: workingGroups })
              : 'Inaktiv',
            entry.get('user').get('vacationType'),
            0,
            0,
          ];
          entry.get('type') === 'kr' ? hashTable[user][5]++ : hashTable[user][6]++;
        }
      }
      return Object.values(hashTable);
    },
    async getSuperior({ state }, { user, wGs }) {
      const result = wGs.filter((wg) =>
        wg.object
          .get('users')
          .map((u) => u.id)
          .includes(user.id)
      );
      const chefs = [];
      result.forEach((r) => {
        const chef = r.object.get('chef');
        const name = chef.get('firstname') + ' ' + chef.get('lastname');
        if (!chefs.includes(name) && chef.id !== user.id) chefs.push(name);
      });
      return chefs.length ? chefs.toString().replace(/,/g, ', ') : '-';
    },
  },
  getters: {
    events: (state) => Object.values(state.events).flat(),
    eventsForADay: (state) => state.eventsForADay,
  },
};

export default AdminCalendarModule;
